import { render, staticRenderFns } from "./event-label-expand.vue?vue&type=template&id=2bc20115&scoped=true&"
import script from "./event-label-expand.vue?vue&type=script&lang=js&"
export * from "./event-label-expand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc20115",
  null
  
)

export default component.exports